import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { User } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const teamMembers = [{
  name: "Dr. Marcus Thorne",
  position: "Chief of Neurosurgery",
  bio: "Specializing in minimally invasive brain and spine procedures with a focus on rapid recovery and surgical precision.",
  specialties: ["BRAIN", "SPINE", "MINIMALLY INVASIVE"],
  initials: "MT",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/team_emily_chen.png"
}, {
  name: "Dr. Sarah Lin",
  position: "Lead Neurologist",
  bio: "Dedicated to non-surgical neurological management, ensuring every patient receives personalized, family-centered care.",
  specialties: ["NEUROLOGY", "DIAGNOSTICS", "REHABILITATION"],
  initials: "SL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/team_alex_ramirez.png"
}];
export default function OurExpertTeam() {
  return <section data-section-id="91897" id="the-multidisciplinary-team" className="bg-background text-foreground py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <h2 className="text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl font-sans">
            The Multidisciplinary Team
          </h2>
          <p className="text-muted-foreground max-w-[800px] text-lg md:text-xl font-sans">
            Our specialists combine surgical precision with compassionate care, treating every patient with the same dedication we would show our own family.
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 justify-center">
          {teamMembers.map((member, i) => <div data-index={i} key={member.name} className="flex justify-center">
              <Card className="group border-border/40 bg-card/60 backdrop-blur-md hover:shadow-xl relative flex w-full max-w-sm flex-col overflow-hidden transition-all duration-500 hover:-translate-y-2">
                <CardHeader className="pb-4 text-center">
                  <SafeHydrate><Avatar className="border-background mx-auto mb-6 size-32 border-4 shadow-md overflow-hidden">
                    <AvatarImage src={member.image} alt={member.name} className="object-cover transition-all duration-700 group-hover:grayscale" />
                    <AvatarFallback className="bg-accent text-accent-foreground text-2xl font-bold">
                      {member.initials}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <CardTitle className="text-foreground text-xl font-bold font-sans">
                    {member.name}
                  </CardTitle>
                  <CardDescription className="text-secondary mt-2 font-medium uppercase tracking-wider text-xs">
                    {member.position}
                  </CardDescription>
                </CardHeader>
                
                <CardContent className="flex-grow text-center pb-2">
                  <div className="mb-4 flex flex-wrap justify-center gap-2">
                    {member.specialties.map((specialty, idx) => <Badge key={idx} variant="secondary" className="bg-transparent border-none text-secondary font-bold text-[10px] tracking-widest hover:bg-transparent">
                        {specialty}
                      </Badge>)}
                  </div>
                  <p className="text-muted-foreground text-sm line-clamp-3 px-2 font-sans italic">
                    "{member.bio}"
                  </p>
                </CardContent>

                <CardFooter className="pt-4 pb-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100 focus-within:opacity-100">
                  <Button variant="outline" className="w-full rounded-full border-secondary/40 text-secondary hover:bg-secondary hover:text-white transition-all duration-300 scale-95 group-hover:scale-100">
                    <User className="mr-2 size-4" />
                    View Bio
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}